<script module lang="ts">
  export const contextKey = Symbol('columns-context');
</script>

<script lang="ts">
  import { setContext } from 'svelte';
  import clsx from 'clsx';
  import type { ColumnsContext, ColumnsProps } from './types';
  import { getFlexClasses } from './utils';
  import { getNegativeMarginLeftClassName } from './spacing';

  const {
    space = 'gutter',
    children,
    collapseBelow,
    reverseWhenCollapsed,
    reverse,
    collapse,
    centered,
    verticallyCentered,
    allWidths,
    class: className,
    action = () => undefined,
    actionArg,
  }: ColumnsProps = $props();
  const context: ColumnsContext = {
    space: () => space,
    collapseBelow: () => collapseBelow,
    collapse: () => collapse,
    reverseWhenCollapsed: () => reverseWhenCollapsed,
    reverse: () => reverse,
    allWidths: () => allWidths,
  };
  setContext(contextKey, context);

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div
  use:elementAction
  class={clsx(
    className,
    centered && 'justify-center',
    verticallyCentered && 'items-center',
    getFlexClasses(collapseBelow, collapse, reverseWhenCollapsed, reverse),
    getNegativeMarginLeftClassName(space),
  )}
>
  {@render children()}
</div>
